module.exports = __webpack_public_path__ + "media/application/images/ui/AjaxLoader-3ce7735e7243d3d3d8d62d42e3d0b82a.gif";